<template>
  <div>
    <el-menu :default-active="activeMenu" router class="el-menu-demo" mode="horizontal" @select="handleSelect"
      active-text-color="#8989ba">
      <div style="float:left;line-height: 60px;height:60px;outline: none;">
        <p style="width: 100px;position: relative;display: inline-block;">
          <span class="log"></span>
        </p>
        <p style=" display: inline-block;color:#999">SFC Order Fulfillment</p>
      </div>
      <template v-for="(item,i) in navList">
        <template v-if="item.childs">
          <el-submenu :key="i" v-if="item.childs" :index="item.name">
            <template slot="title">{{ item.navItem }}</template>
            <el-menu-item v-for="(itemchilds,i) in item.childs" :key="i" :index="itemchilds.name">{{itemchilds.navItem}}
            </el-menu-item>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :key="i" :index="item.name">{{ item.navItem }}</el-menu-item>
        </template>
      </template>
      <div style="float:right;height:60px;outline: none; position: relative;">
        <p class="usea" style="position: absolute; left:-51px">
          <span
            style="width: 40px; height: 40px;border: 1px solid #8989ba;line-height: 40px;text-align: center;border-radius: 50%;color:#8989ba;font-size:20px">{{usea}}</span>
        </p>
        <p class="usea">
          <span>{{getuser}}</span>
          <span>Balance:{{getBalance}}</span>
        </p>
        <p class="usea">
          <span v-bind:class="[isActive ? 'red' : 'greens']" @click="authenticationgo(1)">{{authentication}}</span>
          <span style="color:#8989ba;cursor:pointer;"> <span @click="Rechargedialog">Recharge</span>
            <i v-bind:class="[isClass ? 'el-icon-refresh' : 'el-icon-loading']" @click="refresh"></i> </span>

        </p>
      </div>
    </el-menu>

    <el-dialog title="Recharge" :visible.sync="visible" center width="400px" :close-on-click-modal="false"
      :before-close="handleDialogClose">
      <el-form :model="form" ref="form" :rules="rules2" @submit.native.prevent>
        <el-form-item prop="Amount">
          <el-input type="Amount" v-model="form.Amount" autocomplete="off"
            placeholder="Please enter the amount of recharge">
            <template slot="append">USD</template>
          </el-input>
          <p class="font">The amount of the account is settled in CNY.</p>
          <p class="font">The current exchange rate :
            <span style="color:#f36a21">1USD={{currency}}CNY.</span></p>
          <p class="font">Paypal recharge fee: 0.3usd plus 2.9%~3.4% extra fee (if any)</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="background:#8989ba;color:#fff;outline: none" @click="Recharge('form')">Recharge</el-button>
      </div>
    </el-dialog>
    <iframe :src="iframesrc" style="display: none" v-if="isiframe"></iframe>
  </div>
</template>
<script>
import { getToken } from '../utils/auth'
import { getcurrency, paypal, gettokenuser } from '../views/api/user'
import { getChartFree, isVerify } from '../views/api/home'
import { removeKey } from '../utils/sessionStorage'
import store from '@/store'
console.log(store.getters)
export default {
  data () {
    var checkamount = (rule, value, callback) => {
      console.log(value)
      if (!value) {
        return callback(new Error('The amount cannot be empty'))
      }
      if (!/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/.test(Number(value))) {
        callback(new Error('please enter a number'))
      } else {
        callback()
      }
    }
    return {
      dialogFormVisible: store.getters.recharge,
      currency: '',
      balance: '999.58',
      userId: '',
      isiframe: false,
      //   authentication: "Not Certified",
      AuthenticationStatus: false,
      isActive: true,
      isClass: true,
      iframesrc: '',
      form: {
        Amount: ''
      },
      rules2: {
        Amount: [{ validator: checkamount, trigger: 'blur' }]
      },

      formLabelWidth: '120px',
      navList: [
        {
          name: '/home',
          navItem: 'Home'
        },
        { name: '/MyProducp', navItem: 'My Product' },
        { name: '/AsnOrder', navItem: 'ASN Order' },
        { name: '/OrderManagement', navItem: 'Order Management' },
        { name: '/Finance', navItem: 'Bill' },
        {
          name: '',
          navItem: 'More',
          childs: [
            {
              name: '/Setting',
              navItem: 'Rule setting'
            }
            // {
            //  name: "/PriceList",
            // navItem: "Price List"
            // },
            // {
            //  name: "/accountManager",
            //  navItem: "Account Manager"
            // }
          ]
        }
      ]
    }
  },
  computed: {
    visible () {
      return store.getters.recharge
    },
    getBalance () {
      return store.getters.balance
    },
    getuser () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.userId = store.getters.user
      return store.getters.user
    },
    usea () {
      let usea = store.getters.user
      return usea.substring(0, 1)
    },
    activeMenu () {
      return store.getters.menu
    },
    authentication () {
      return store.getters.status
    },
    userMsg () {
      return store.getters.user
    },
    tokenMsg () {
      return store.getters.token
    }
  },
  mounted () {

    // let usea = store.getters.user;
    // this.usea = usea.substring(0, 1);

  },
  // computed: {
  //   listenChange () {
  //     const {name1, name2} = this
  //     return {name1, name2}
  //   }
  // },

  watch: {
    userMsg: function (val) {
      if (val && this.tokenMsg) {
        this.getVerify()
      }
    },
    tokenMsg: function (val) {
      if (val && this.userMsg) {
        this.getVerify()
      }
    }
  },
  created () {
    setTimeout(() => {
      this.authenticationgo(0)
    }, 300)
    this.getVerify()
  },
  methods: {
    getVerify () {
      if (store.getters.user && store.getters.token) {
        isVerify().then(response => {
          console.log(response)
          if (response.data.ask === 1) {
            if (response.data.urlcode === '200') {
              store.dispatch('updateStatus', 'Certified')
              this.isActive = false
            } else {
              store.dispatch('updateStatus', 'Not Certified')
              this.isActive = true
            }
          } else {
          // window.open("http://ffment.sendfromchina.com/activation/activation");
          // https://markplace.sfcservice.com/platform/shopify-app/get-token?customer_id=xxxx

            console.log('Acquire authentication status：' + response.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    handleSelect (key, keyPath) {
      store.dispatch('updatemenu', '')
    },
    Recharge (formName) {
      var Thsy = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0,0, 0,.7)'
          })
          let param = {
            currency_code: 'USD',
            amount: this.form.Amount
          }
          paypal(param)
            .then(response => {
              if (response.data.ask == 1) {
                console.log(response)

                // this.currency=response.data.data.rate
                window.top.location.href = response.data.approve_url
                // loading.close();
                let form = 'form'
                // this.$refs[form].resetFields();
                //   this.dialogFormVisible = false;
                // store.dispatch('Recharge', false)
              } else {
                loading.close()
              }
            })
            .catch(error => {
              console.log(error)
            })

            // Thsy.dialogFormVisible = false;
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    authenticationgo (type) {
      console.log('menu', store.getters.shopTokenuser)
      console.log(typeof store.getters.shopTokenuser)
      let param = {
        // customer_id: JSON.parse(getToken("user")).customer_id, 这里
        customer_id: store.getters.shopTokenuser.customer_id,
        secretkey: '3d878b3aeae9d5d389a7c82a27708c6a'
        //
      }
      gettokenuser(param)
        .then(response => {
          this.loading = false
          if (response.data.ask == 1) {
            document.cookie =
                'token=' +
                response.data.token +
                ';path=/;domain=.sendfromchina.com'
            this.isiframe = true
            this.iframesrc = 'https://www.sendfromchina.com/user/login/login-from-customer-system?token=' + response.data.token
            if (type == 1) {
              window.open('http://ffment.sendfromchina.com/activation/activation')
            }
          }
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    Rechargedialog () {
      let param = {
        currency_code: 'USD'
      }

      getcurrency(param)
        .then(response => {
          if (response.data.ask == 1) {
            console.log(response)
            this.currency = response.data.data.rate
            store.dispatch('Recharge', true)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleDialogClose () {
      let form = 'form'
      this.$refs[form].resetFields()
      store.dispatch('Recharge', false)
    },
    refresh () {
      this.isClass = false
      const params = { customer_id: this.userId }
      getChartFree(params).then(response => {
        console.log(response)
        removeKey('balance')
        this.isClass = true
        if (response.data.ask === 1 && response.data.data) {
          this.balance = response.data.data.balance
          store.dispatch('updateBalance', this.balance)
        }
      }).catch(err => {
        this.isClass = true
        console.log(err)
      })
    }
  }
}
</script>
<style>
  .log {
    height: 37px;
    width: 82px;
    background: url("./img/SFC-logo.png");
    display: inline-block;
    background-size: cover;
    position: absolute;
    left: 0;
    top: -23px;
  }

  .font {
    font-size: 14px;
    color: #bbb;
    line-height: 20px;
  }

  .usea {
    position: relative;
    display: inline-block;
    padding: 10px;
    color: #333;
  }

  .red {
    color: #ff0000;
  }

  .greens {
    color: rgb(137, 137, 186);
  }

  .usea>span {
    display: block;
    height: 20px;
    line-height: 20px;
    text-align: left;
    font-size: 14px;
  }

  .usea img {
    width: 40px;
    height: 40px;
    display: inline-block;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/menu.vue